import React from 'react';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
import GetProxy from "../../../common/GetProxy";
import { handleResponseCode } from '../../../../app/utilities/helpers';
const proxy = GetProxy();
const cookies = new Cookies();

export const regexCustomizationTable = createAsyncThunk(
    "posts/getCustomizationTable",
    async (props) => {
        const { pageNumber, itemsPerPage, payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/RegexCustomization/getPIIRegexListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }

    });


export const regexCustomizationCount = createAsyncThunk(
    "posts/getCustomizationCount",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/RegexCustomization/getPIIRegexListCount`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }


    });

export const RegexSave = createAsyncThunk(
    "posts/getRegexSave",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/RegexCustomization/saveNewPIIRegexCustomization`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }


    });
export const RegexStatus = createAsyncThunk(
    "posts/getRegexStatus",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/RegexCustomization/setActiveOrInactiveStatus`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }

    });
export const RegexDelete = createAsyncThunk(
    "posts/getRegexDelete",
    async (props) => {
        const { id } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const res = await fetch(`${proxy}/api/v1/PII/RegexCustomization/deletePIIRegexCustomization/${id}`, {
                method: 'DELETE',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                }
            });
            handleResponseCode(res);
            const data  = await res.json();
            return res.ok ? data : Promise.reject(data);
        } catch (error) {
            return error;
        }
    }
);
export const WhitelistedTable = createAsyncThunk(
    "posts/getWhitelisted ",
    async (props) => {
        const { pageNumber, itemsPerPage, payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/WhitelistedData/getWhiteListedListWithSearchAndPagination/${pageNumber}/${itemsPerPage}`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }


    });

export const WhitelistedTableCount = createAsyncThunk(
    "posts/getWhitelistedCount",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/WhitelistedData/getWhiteListedListCount`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }

    });

export const WhiteListSave = createAsyncThunk(
    "posts/getWhiteListSave",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/WhitelistedData/savePiiWhiteList`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }

    });
export const WhiteListDelete = createAsyncThunk(
    "posts/getWhiteListDelete",
    async (props) => {
        const { id } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/WhitelistedData/deletePiiWhiteList/${id}`, {
                method: 'DELETE',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                }
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            return error;
        }
    }
);
export const WhiteListStatus = createAsyncThunk(
    "posts/getWhiteListStatus",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        try {
            const response = await fetch(`${proxy}/api/v1/PII/WhitelistedData/setActiveOrInactiveStatus`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": Apitoken,
                    USERNAME: User,
                },
                body: JSON.stringify(payload)
            })
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.log(error)
            throw error;
        }

    });
export const PIIConfigurationSlice = createSlice({
    name: 'PIIConfigurationSlice',
    initialState: {
        regexCustomizationTableData: [],
        rCTableLoading: false,
        regexCustomizationDataCount: [],
        rCTableCountLoading: false,
        RegexSaveData: '',
        RegexSaveLoading: false,
        RegexStatusData: [],
        RegexStatusLoading: false,
        RegexTableReload: false,
        RegexDeleteData: '',
        RegexDeleteLoading: false,
        // Whitelisted Details
        WhitelistedTableData: [],
        WhitelistedLoading: false,
        WhitelistedTableCount: [],
        WhitelistedTableCountLoading: false,
        WhiteListSaveData: '',
        WhiteListSaveLoading: false,
        WhitelistedTableReload: false,
        WhiteListDeleteData: '',
        WhiteListDeleteLoading: false,
        WhiteListStatusData: [],
        WhiteListStatusLoading: false,
        error : false,
    },

    reducers: {
        setEmptyRegexDeleteData: (state) => {
            state.RegexDeleteData = '';
        },
        setEmptyRegexSaveData: (state) => {
            state.RegexSaveData = '';
        },
        setEmptyWhiteListSaveData: (state) => {
            state.WhiteListSaveData = '';
        },
        setEmptyWhiteListDeleteData: (state) => {
            state.WhiteListDeleteData = '';
        },
        setError: (state) => {
            state.error = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(regexCustomizationTable.pending, (state, action) => {
                state.rCTableLoading = true;
                state.error = false;
            })
            .addCase(regexCustomizationTable.fulfilled, (state, action) => {
                state.regexCustomizationTableData = action.payload;
                state.rCTableLoading = false;
                state.RegexTableReload = false;
                state.error = false;
            })
            .addCase(regexCustomizationTable.rejected, (state, action) => {
                state.rCTableLoading = false;
                state.error = true;
            })

            .addCase(regexCustomizationCount.pending, (state, action) => {
                state.rCTableCountLoading = true;
                state.error = false;
            })
            .addCase(regexCustomizationCount.fulfilled, (state, action) => {
                state.regexCustomizationDataCount = action.payload;
                state.rCTableCountLoading = false;
                state.error = false;
            })
            .addCase(regexCustomizationCount.rejected, (state, action) => {
                state.rCTableCountLoading = false;
                state.error = true;
            })

            .addCase(RegexSave.pending, (state, action) => {
                state.RegexSaveLoading = true;
                state.error = false;
            })
            .addCase(RegexSave.fulfilled, (state, action) => {
                state.RegexSaveData = 'Saved Successfully';
                state.RegexSaveLoading = false;
                state.RegexTableReload = true;
                state.error = false;
            })
            .addCase(RegexSave.rejected, (state, action) => {
                state.RegexSaveData = 'Save Failed';
                state.RegexSaveLoading = false;
                state.error = true;
            })

            .addCase(RegexStatus.pending, (state, action) => {
                state.RegexStatusLoading = true;
                state.error = false;
            })
            .addCase(RegexStatus.fulfilled, (state, action) => {
                state.RegexStatusData = action.payload;
                state.RegexStatusLoading = false;
                state.RegexTableReload = true;
                state.error = false;
            })
            .addCase(RegexStatus.rejected, (state, action) => {
                state.RegexStatusLoading = false;
                state.error = true;
            })

            .addCase(RegexDelete.pending, (state, action) => {
                state.RegexDeleteLoading = true;
                state.error = false;
            })
            .addCase(RegexDelete.fulfilled, (state, action) => {
                state.RegexDeleteData = 'Deleted Successfully';
                state.RegexDeleteLoading = false;
                state.RegexTableReload = true;
                state.error = false;
            })
            .addCase(RegexDelete.rejected, (state, action) => {
                state.RegexDeleteData = 'Delete Failed';
                state.RegexDeleteLoading = false;
                state.error = true;
            })
            // Whitelisted Details

            .addCase(WhitelistedTable.pending, (state, action) => {
                state.WhitelistedLoading = true;
                state.error = false;
            })
            .addCase(WhitelistedTable.fulfilled, (state, action) => {
                state.WhitelistedTableData = action.payload;
                state.WhitelistedLoading = false;
                state.WhitelistedTableReload = false;
                state.error = false;
            })
            .addCase(WhitelistedTable.rejected, (state, action) => {
                state.WhitelistedLoading = false;
                state.error = true;
            })

            .addCase(WhitelistedTableCount.pending, (state, action) => {
                state.WhitelistedTableCountLoading = true;
                state.error = false;
            })
            .addCase(WhitelistedTableCount.fulfilled, (state, action) => {
                state.WhitelistedTableCount = action.payload;
                state.WhitelistedTableCountLoading = false;
                state.error = false;
            })
            .addCase(WhitelistedTableCount.rejected, (state, action) => {
                state.WhitelistedTableCountLoading = false;
                state.error = true;
            })

            .addCase(WhiteListSave.pending, (state, action) => {
                state.WhiteListSaveLoading = true;
                state.error = false;
            })
            .addCase(WhiteListSave.fulfilled, (state, action) => {
                state.WhiteListSaveData = "Saved Successfully";
                state.WhiteListSaveLoading = false;
                state.WhitelistedTableReload = true;
                state.error = false;
            })
            .addCase(WhiteListSave.rejected, (state, action) => {
                state.WhiteListSaveData = "Save Failed";
                state.WhiteListSaveLoading = false;
                state.error = true;
            })

            .addCase(WhiteListDelete.pending, (state, action) => {
                state.WhiteListDeleteLoading = true;
                state.error = false;
            })
            .addCase(WhiteListDelete.fulfilled, (state, action) => {
                state.WhiteListDeleteData = 'Deleted Successfully';
                state.WhiteListDeleteLoading = false;
                state.WhitelistedTableReload = true;
                state.error = false;
            })
            .addCase(WhiteListDelete.rejected, (state, action) => {
                state.WhiteListDeleteData = 'Delete Failed';
                state.WhiteListDeleteLoading = false;
                state.error = true;
            })

            .addCase(WhiteListStatus.pending, (state, action) => {
                state.WhiteListStatusLoading = true;
                state.error = false;
            })
            .addCase(WhiteListStatus.fulfilled, (state, action) => {
                state.WhiteListStatusData = action.payload;
                state.WhiteListStatusLoading = false;
                state.WhitelistedTableReload = true;
                state.error = false;
            })
            .addCase(WhiteListStatus.rejected, (state, action) => {
                state.WhiteListStatusLoading = false;
                state.error = true;
            })

    },

});

export const { setEmptyRegexDeleteData, setEmptyRegexSaveData, setEmptyWhiteListSaveData, setEmptyWhiteListDeleteData, setError } = PIIConfigurationSlice.actions;
export default PIIConfigurationSlice.reducer;